/** Patches root-owned LanguageConstants strings until LanguageConstants.ts can be edited. */
export function applyLanguageDisplayOverrides(): void {
  // Lazy require avoids circular init: Constants -> Helper -> Constants when loaded from index.tsx.
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const { getFromStorage } = require('../utils/Helper') as typeof import('../utils/Helper');
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const { StorageConstant } = require('./Constants') as typeof import('./Constants');
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const { LanguageConstants } = require('./LanguageConstants') as typeof import('./LanguageConstants');

  const isSpanish = () => getFromStorage({ key: StorageConstant?.Translate }) === 'spa';

  LanguageConstants.SURVEY_REVIEW_PLACEHOLDER = isSpanish()
    ? 'Cuentanos tu experiencia.'
    : 'Tell us your experience.';

  (LanguageConstants as Record<string, string>).QUOTE_SEARCH_QUOTE_ID = isSpanish()
    ? 'Buscar por ID de cotización'
    : 'Search by Quote ID';

  if (isSpanish() && LanguageConstants.SAVE === 'Ahorrar') {
    LanguageConstants.SAVE = 'Guardar';
  }

  if (!isSpanish()) return;

  const spanishItemLabelOverrides: Record<string, string> = {
    Item_Name: 'Nombre del Item',
    ADDMOREPRODUCT: 'Agregar otro Item',
    ADDMORE: 'Agregar nuevo Item',
    SAVE_FOR_LATER_MIN_ENTRY:
      'Complete al menos un campo del Item en la pestaña de entrada de datos antes de guardar en borradores.',
    ADD_ITEM_PLUS: 'Añadir Item',
    MANUAL_DRAFTS_COL_ITEMS: 'Items',
    MANUAL_DRAFTS_STEP_1: 'Items',
    MANUAL_QUOTE_COMPLETE_ITEMS:
      'Complete todos los campos obligatorios de los Items antes de continuar.',
    VIEW_QUOTE_SEARCH_ITEMS: 'Buscar Items',
    VIEW_QUOTE_ITEMS_COUNT: 'Items',
    VIEW_QUOTE_NOTES_ITEM_HINT: 'Las notas del administrador se muestran por Item a continuación.',
    VIEW_QUOTE_NO_ITEMS: 'Ningún Item coincide con su búsqueda.',
    VIEW_QUOTE_NO_ITEMS_AT_ALL: 'Aún no hay Items.',
    DRAFTS: 'Borrador',
    ORDER_COL_MSG: 'Msj',
    ORDER_COL_PMT_STATUS: 'Estado del pago',
  };

  for (const [key, value] of Object.entries(spanishItemLabelOverrides)) {
    (LanguageConstants as Record<string, string>)[key] = value;
  }
}
